
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import HtmlContent from '@/components/molecules/HtmlContent.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'
import DateUtils from '@/utils/DateUtils'

/**
 * お知らせメッセージ詳細画面
 */
@Component({
  components: {
    ImageBase,
    TitlePage,
    PanelFrame,
    HtmlContent,
  },
})
export default class NoticeMessagePanel extends Vue {
  /** メッセージ情報 */
  @Prop()
  private message!: NoticeMessageData

  /**
   * お知らせの日付
   *
   * @param date 日付情報
   * @returns フォーマットされた日付
   */
  private dateFormat(date: Date): string {
    return DateUtils.format(date)
  }

  /**
   * 日付を開始〜終了の形式で返す
   *
   * @param start 開始日
   * @param end 終了日
   * @returns 表示用の形式になった日付
   */
  private dateStartToEnd(start: string, end: string): string {
    return DateUtils.startToEnd(start, end)
  }
}
